import React, { useEffect } from 'react';
import cn from 'classnames';
import SignInWrap from '@app/activity/BlackFridayCheckIn/components/SignInWrap';
import styles from './index.module.less';
import useBlackFridayCheckIn from '@base/activity/blackFridayCheckIn/useBlackFridayCheckIn';
import VideoWrap from '@app/activity/BlackFridayCheckIn/components/VideoWrap';
import { trackPageView } from 'base/utils/tracker';
import { pages } from 'pro/config/pages';

type IProps = {}

// Modal 或 Drawer的配置
export const popupProps = {
    className: styles['black-friday-sign-in-modal'],
    bodyStyle: {
        padding: 0,
        paddingTop: 50,
        background: '',
    },
    centered: true,
    footer: false,
    width: 1200,
}

const BlackFridayCheckIn: React.FC<IProps> = (props) => {

    const checkIn = useBlackFridayCheckIn();

    useEffect(()=> {
        trackPageView({
            viewType: pages.blackFridayCheckIn.viewType,
            detail: 'black_friday_check_in'
        })
    }, [])

    return (
        <div className={cn('flex', styles['black-friday-sign-in-wrap'])}>

            <div className={cn(styles['video-wrap'])}>
                <VideoWrap checkIn={checkIn}/>
            </div>

            <div className={cn('flex-1', styles['sign-in-warp'])}>
                <SignInWrap checkIn={checkIn}/>
            </div>
        </div>
    );
};

export default BlackFridayCheckIn